<template>
    <div>
        <div class="form-container mr-auto ml-auto mt-3" v-if="field.helpDescription !== null">
            <v-alert type="info" class="mt-5 mb-5 mr-auto ml-auto" border="right" colored-border>
                {{ field.helpDescription }}
            </v-alert>
        </div>

        <v-alert type="warning" v-if="provider.price_periods.length === 0 && !disabled"
                 class="mt-5 mb-5 form-container mr-auto ml-auto" border="right" colored-border>
            <p>
                Vous n'avez pas renseigné vos tarifs. Il s'agit d'une information importante pour vos visiteurs.
            </p>
            <p>
                Nous vous suggérons de prendre quelques minutes pour bien renseigner vos tarifs.
            </p>
        </v-alert>
    </div>
</template>

<script>
import {mapState} from "vuex"

export default {
    name: "PricePeriodTopAlerts",
    props: ['field'],
    computed: {
        ...mapState("web_form", ['provider', 'disabled'])
    }
}
</script>
